import readCookie from '../readCookie';
import storageAvailable from '../storageAvailable';
/**
 * Gets a value from storage. Defaults to looking in localStorage, but can be
 * changed via function params. Will fall back to using cookies if localStorage
 * or sessionStorage are not available.
 *
 * @param {Object} options The options for the storage function
 * @param {string} options.key The key that the value is stored under
 * @param {Boolean} options.session Should the function look for the value in sessionStorage?
 * @param {Boolean} options.forceCookies Should the function look for the value in cookies?
 * @return {string} The value stored in the specified storage
 *
 * @public
 * @author Alex Kasemir
 */

var getStorage = function getStorage(_ref) {
  var key = _ref.key,
      _ref$session = _ref.session,
      session = _ref$session === void 0 ? false : _ref$session,
      _ref$forceCookies = _ref.forceCookies,
      forceCookies = _ref$forceCookies === void 0 ? false : _ref$forceCookies;
  var windowStorage = session ? "sessionStorage" : "localStorage";
  var useCookies = forceCookies || !storageAvailable(windowStorage);
  var data;

  if (useCookies) {
    data = readCookie(key);
  } else {
    data = window[windowStorage].getItem(key);
  }

  try {
    data = JSON.parse(data);
  } catch (e) {} // eslint-disable-line


  return data;
};
/** @component */


export default getStorage;